import React, { useCallback, useEffect, useState, useContext } from 'react';
import "./Flowchart.scss"

import {
  ReactFlow,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import CustomNode from '../../components/Nodes/CustomNode';

import ModalEmpleadoGerente from '../../components/Modales/Flowchart/ModalEmpleadoGerente';

import { jwtDecode } from "jwt-decode"
import { useAdmin } from '../../context/AdminContext';
import { AreaContext } from '../../context/AreaContext';

const nodeTypes = {
  custom: CustomNode
};

export const flowchartGerenteContext = React.createContext()

function FlowchartEmpleados() {

  const auth = localStorage.getItem("token")
  const jwtParse = jwtDecode(auth)
  const USER = jwtParse.apirest.objeto

  const { areas, setAreas } = useContext(AreaContext)

  const { empleados, fetchEmpleadosById, fetchArea, setErrorArea } = useAdmin()

  const [modalEmpleado, setModalEmpleado] = useState(false)
  const [idEmpresaFlow, setIdEmpresaFlow] = useState(null)

  const [nodes, setNodes, onNodesChange] = useNodesState([])
  const [edges, setEdges, onEdgesChange] = useEdgesState([])

  useEffect(()=>{
    fetchArea(USER, USER.idEmpresa)
    .then(res => {
        if(res.status !== 0){
          setErrorArea(res.codeError)
        } else {
          setAreas(res.objeto)
        }
    })
    fetchEmpleadosById(USER, USER.idEmpresa)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  useEffect(()=>{
    totalNodes()
    totalEdges()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empleados])

  const handleModalEmpleado = (id) => {
    setIdEmpresaFlow(parseInt(id))
    setModalEmpleado(true)
  }

  const spacingX = 180;
  const spacingY = 60;
  const empGap   = 60;

  const totalNodes = async () => {

    const nodes = [
      {
        id: 'parent',
        position: { x: 0, y: 0 },
        data: { label: 'Empresa' },
        style: { backgroundColor: '#9ec5fe' },
      },
    ];

    const gerente = empleados.find((e) => e.fk_puesto === 3);
    const subordinados = empleados.filter((e) => e.fk_puesto === 4 || e.fk_puesto === 5 || e.fk_puesto === 6 || e.fk_puesto === 7);

    if (!gerente) {
      setNodes(nodes);           // no hay gerente → nada más que pintar
      return;
    }

    nodes.push({
      id: `empleado-${gerente.id_empleado}`,
      position: { x: 0, y: spacingY },
      data: { label: gerente.nombre },
      parentNode: 'parent',
      extent: 'parent',
      style: { backgroundColor: '#e6efff' },
    });

    const offsetX = ((areas.length - 1) * spacingX) / 2;

    areas.forEach((area, areaIndex) => {
      const x = areaIndex * spacingX - offsetX;       // centrar áreas
      const empleadosArea = subordinados.filter(
        (e) => e.fk_area === area.id_area
      );

      /* área */
      nodes.push({
        id: `area-${area.id_area}`,
        position: { x, y: spacingY * 2 },
        data: { label: area.nombre_del_Area },
        parentNode: 'parent',
        extent: 'parent',
        style: { backgroundColor: '#d1e7dd' },
      });

      /* empleados del área */
      empleadosArea.forEach((emp, idx) => {
        nodes.push({
          id: `empleado-${emp.id_empleado}`,
          position: { x, y: spacingY * 3 + idx * empGap },
          data: { label: emp.nombre },
          parentNode: 'parent',
          extent: 'parent',
          style: { backgroundColor: '#f8f9fa' },
        });
      });

      /* botón “+ Agregar” */
      nodes.push({
        id: `add-btn-area-${area.id_area}`,
        type: 'custom',
        position: {
          x,
          y: spacingY * 3 + empleadosArea.length * empGap,
        },
        data: {
          label: '+ Agregar',
          onClick: () => handleModalEmpleado(USER.idEmpresa),
        },
        parentNode: 'parent',
        extent: 'parent',
      });
    });

    /* empleados SIN área (puestos 6 y 7 sin fk_area) */
    const empleadosSinArea = subordinados.filter(
      (e) => (e.fk_puesto === 6 || e.fk_puesto === 7) && !e.fk_area
    );

    if (empleadosSinArea.length > 0) {
      const sinAreaX = offsetX + spacingX; // a la derecha de las áreas
      nodes.push({
        id: 'area-sin-area',
        position: { x: sinAreaX, y: spacingY * 2 },
        data: { label: 'Sin área' },
        parentNode: 'parent',
        extent: 'parent',
        style: { backgroundColor: '#ffeeba' },
      });

      empleadosSinArea.forEach((emp, idx) => {
        nodes.push({
          id: `empleado-${emp.id_empleado}`,
          position: { x: sinAreaX, y: spacingY * 3 + idx * empGap },
          data: { label: emp.nombre },
          parentNode: 'parent',
          extent: 'parent',
          style: { backgroundColor: '#f8f9fa' },
        });
      });
    }

    setNodes(nodes);
  };


  const totalEdges = () => {
    const edges = [];
    const gerente = empleados.find((e) => e.fk_puesto === 3);
    const subordinados = empleados.filter((e) => e.fk_puesto === 4 || e.fk_puesto === 5 || e.fk_puesto === 6 || e.fk_puesto === 7);

    if (!gerente) {
      setEdges([]);
      return;
    }

    /* Empresa ➜ Gerente */
    edges.push({
      id: 'edge-parent-gerente',
      source: 'parent',
      target: `empleado-${gerente.id_empleado}`,
    });

    areas.forEach((area) => {
      const areaId     = `area-${area.id_area}`;
      const addBtnId   = `add-btn-area-${area.id_area}`;
      const empsInArea = subordinados.filter((e) => e.fk_area === area.id_area);

      /* Gerente ➜ Área */
      edges.push({
        id: `edge-gerente-area-${area.id_area}`,
        source: `empleado-${gerente.id_empleado}`,
        target: areaId,
      });

      /* Área ➜ Empleados */
      empsInArea.forEach((emp) => {
        edges.push({
          id: `edge-area-${area.id_area}-emp-${emp.id_empleado}`,
          source: areaId,
          target: `empleado-${emp.id_empleado}`,
        });
      });

      /* Área ➜ Botón “+ Agregar”  (una sola vez por área) */
      edges.push({
        id: `edge-area-${area.id_area}-addbtn`,
        source: areaId,
        target: addBtnId,
      });
    });

    /* Empleados SIN área */
    const empleadosSinArea = subordinados.filter(
      (e) => (e.fk_puesto === 6 || e.fk_puesto === 7) && !e.fk_area
    );

    if (empleadosSinArea.length > 0) {
      edges.push({
        id: 'edge-gerente-sinarea',
        source: `empleado-${gerente.id_empleado}`,
        target: 'area-sin-area',
      });

      empleadosSinArea.forEach((emp) => {
        edges.push({
          id: `edge-sinarea-emp-${emp.id_empleado}`,
          source: 'area-sin-area',
          target: `empleado-${emp.id_empleado}`,
        });
      });
    }

    setEdges(edges);
  };

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    [setEdges],
  );

  return (
    <>
      <flowchartGerenteContext.Provider value={{ idEmpresaFlow, fetchEmpleadosById, totalNodes }}>
        <ModalEmpleadoGerente show={modalEmpleado} onHide={()=>setModalEmpleado(false)} />
        <div className='section__header d-flex flex-row align-items-end mb-4'>
          <i className='bi bi-people-fill me-2'></i>
          <h4 className='m-0'>Admin</h4>
        </div>
        {/* Flowchart */}
        <div className='flow border border-1'>
          <ReactFlow
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            nodeTypes={nodeTypes}
            onConnect={onConnect}
            onInit={(instance) => {
              instance.fitView({ minZoom: 0.7, maxZoom: 1 });
            }}
          >
            <Controls />
            <MiniMap />
            <Background variant="dots" gap={12} size={1} />
          </ReactFlow>
        </div>
      </flowchartGerenteContext.Provider>
    </>
  )
}

export default FlowchartEmpleados